import { useState, useEffect } from "react";
import { apiFetch, getToken, clearToken } from "../../api/api";

// ── Layout components ──────────────────────────────────────────────────────────
import AdminSidebar from "../components/common/Adminsidebar";
import AdminTopbar  from "../components/common/Admintopbar";
import AdminLogin    from "./AdminLogin";





// ── Page imports ───────────────────────────────────────────────────────────────
import ProductsAdmin  from "./ProductsAdmin";
import OrdersAdmin    from "./Orderadmin";
import CustomersAdmin from "./Customersadmin";
import ReviewsAdmin   from "./Reviewsadmin";
import CouponsAdmin   from "./Couponsadmin";
import InventoryAdmin from "./Inventoryadmin";
import PhotobooksAdmin from "./PhotobooksAdmin";
import PhotobookOrdersAdmin from "./PhotobookOrdersAdmin";  
import HomeCircle from "./HomeCircle"; 
import Homedaily from "./Homedaily";
import Homeslider from "./Homeslider";
import Newsletter from "./Newsletter";
import HomeVideo from "./HomeVideo";

import AnalyticsAdmin from "./Analyticsadmin";

import BlogsAdmin     from "./Blogsadmin";
import SettingsAdmin  from "./Settingsadmin";
import LeadsAdmin     from "./Leadsadmin";


// ── Tokens ────────────────────────────────────────────────────────────────────

import { T } from "../data/Tokens";
import InquiriesAdmin from "./Inquiriesadmin";
import HomeDaily from "./Homedaily";
import HomeSlider from "./Homeslider";
import HomeNotebook from "./Homenotebook";
import HomePromotional from "./HomePromotional";
import HomeClientSuccess from "./Homeclient";
import { Home } from "lucide-react";




// ── Mini chart helpers (for Dashboard home only) ──────────────────────────────
const MONTHLY = [42,55,48,67,71,58,80,74,90,82,104,112];
const MONTHS  = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
const SALES_PTS = [20,30,22,32,40,38,47];
const DAYS = ["12 May","13 May","14 May","15 May","16 May","17 May","18 May"];

// Small helper: is the viewport a "compact" (phone) width right now?
function useIsMobile(breakpoint = 1024) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < breakpoint : false
  );
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [breakpoint]);
  return isMobile;
}

function LineChartSVG() {
  const W=480,H=160,PL=36,PR=12,PT=12,PB=28,max=50,min=0;
  const cW=W-PL-PR,cH=H-PT-PB;
  const pts=SALES_PTS.map((v,i)=>[PL+(i/(SALES_PTS.length-1))*cW,PT+cH-((v-min)/(max-min))*cH]);
  const d=pts.map((p,i)=>i===0?`M${p[0].toFixed(1)},${p[1].toFixed(1)}`:`C${((pts[i-1][0]+p[0])/2).toFixed(1)},${pts[i-1][1].toFixed(1)} ${((pts[i-1][0]+p[0])/2).toFixed(1)},${p[1].toFixed(1)} ${p[0].toFixed(1)},${p[1].toFixed(1)}`).join(" ");
  const fill=`${d} L${pts[pts.length-1][0]},${PT+cH} L${pts[0][0]},${PT+cH} Z`;
  return (
    <svg viewBox={`0 0 ${W} ${H}`} className="w-full" style={{height:160}}>
      <defs><linearGradient id="gGrad" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor={T.gold} stopOpacity="0.25"/><stop offset="100%" stopColor={T.gold} stopOpacity="0.02"/></linearGradient></defs>
      {[0,10,20,30,40,50].map(v=>{const y=PT+cH-((v-min)/(max-min))*cH;return(<g key={v}><line x1={PL} y1={y} x2={W-PR} y2={y} stroke={T.border} strokeWidth="1"/><text x={PL-6} y={y+4} textAnchor="end" fontSize="9" fill={T.textSec}>{v===0?"0":`${v}K`}</text></g>);})}
      {DAYS.map((d,i)=>{const x=PL+(i/(DAYS.length-1))*(W-PL-PR);return<text key={d} x={x} y={H-5} textAnchor="middle" fontSize="9" fill={T.textSec}>{d}</text>;})}
      <path d={fill} fill="url(#gGrad)"/>
      <path d={d} fill="none" stroke={T.gold} strokeWidth="2.5" strokeLinecap="round"/>
      {pts.map(([x,y],i)=><g key={i}><circle cx={x} cy={y} r="5" fill="white" stroke={T.gold} strokeWidth="2"/><circle cx={x} cy={y} r="2" fill={T.gold}/></g>)}
    </svg>
  );
}

function BarChartSVG() {
  const W=480,H=160,PL=32,PR=8,PT=12,PB=28,max=120;
  const cW=W-PL-PR,cH=H-PT-PB,bw=Math.floor(cW/MONTHS.length)-6;
  return (
    <svg viewBox={`0 0 ${W} ${H}`} className="w-full" style={{height:160}}>
      {[0,30,60,90,120].map(v=>{const y=PT+cH-((v/max)*cH);return<g key={v}><line x1={PL} y1={y} x2={W-PR} y2={y} stroke={T.border} strokeWidth="1"/><text x={PL-4} y={y+4} textAnchor="end" fontSize="9" fill={T.textSec}>{v}</text></g>;})}
      {MONTHLY.map((v,i)=>{const x=PL+i*(cW/MONTHS.length)+4,bh=(v/max)*cH,y=PT+cH-bh;return(<g key={i}><rect x={x} y={y} width={bw} height={bh} rx="4" fill={T.gold} opacity="0.85"/><text x={x+bw/2} y={H-5} textAnchor="middle" fontSize="8.5" fill={T.textSec}>{MONTHS[i]}</text></g>);})}
    </svg>
  );
}

function DonutSVG({ data, total, label, size=140 }) {
  let cum=0;
  const cx=size/2,cy=size/2,R=size/2-12,ir=size/2-34;
  const toRad=p=>(p/100)*2*Math.PI;
  const toXY=(a,r)=>[cx+r*Math.cos(a-Math.PI/2),cy+r*Math.sin(a-Math.PI/2)];
  return (
    <svg viewBox={`0 0 ${size} ${size}`} style={{width:size,height:size,flexShrink:0}}>
      {data.map((s,i)=>{
        const start=cum; cum+=s.pct/100;
        const sa=toRad(start*100),ea=toRad(cum*100);
        const[x1,y1]=toXY(sa,R),[x2,y2]=toXY(ea,R);
        const lg=s.pct>50?1:0;
        return <path key={i} d={`M${cx},${cy} L${x1},${y1} A${R},${R} 0 ${lg} 1 ${x2},${y2} Z`} fill={s.color}/>;
      })}
      <circle cx={cx} cy={cy} r={ir} fill="white"/>
      {total && <text x={cx} y={cy-7} textAnchor="middle" fontSize="16" fontWeight="700" fill={T.textPri}>{total}</text>}
      <text x={cx} y={total?cy+10:cy+5} textAnchor="middle" fontSize="10" fill={T.textSec}>{label}</text>
    </svg>
  );
}

// ── Dashboard home page ────────────────────────────────────────────────────────
function DashboardHome({ setActive }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState("");

 useEffect(() => {
    let isMounted = true;

    const fetchDashboardData = (showLoader = false) => {
      if (showLoader) {
        setLoading(true);
        setLoadError("");
      }
      apiFetch("/dashboard/summary.php")
        .then(res => {
          if (isMounted) setData(res.data);
        })
        .catch(err => {
          if (isMounted && showLoader) {
            setLoadError(err.message || "Failed to load dashboard.");
          }
        })
        .finally(() => {
          if (isMounted && showLoader) {
            setLoading(false);
          }
        });
    };

    // Pehli baar load hone par spinner dikhayega
    fetchDashboardData(true);

    // Har 30 seconds mein bina loader ke background mein data refresh hoga
    const interval = setInterval(() => {
      fetchDashboardData(false);
    }, 30000);

    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, []);

  const Avatar = ({ name }) => {
    const ini = name.split(" ").map(n=>n[0]).join("");
    return <div className="w-7 h-7 rounded-full flex items-center justify-center text-[10px] font-bold flex-shrink-0"
      style={{ background:T.goldL, color:T.goldD, border:`1.5px solid ${T.champagne}` }}>{ini}</div>;
  };

  const paymentLabel = (o) => (o.payMethod === "COD" && o.pay === "Pending") ? "COD" : o.pay;

  const spMap = { Completed:"#EEFAF0:#4CAF6E", Delivered:"#EEFAF0:#4CAF6E", Processing:"#FFF8EC:#E8B04A",
  Pending:"#FFF0F0:#E27C7C", Cancelled:"#F5F5F5:#9E9E9E", Paid:"#EEFAF0:#4CAF6E",
  Failed:"#FFF0F0:#E27C7C", COD:"#FFF8EC:#E8B04A" };
  const SPill = ({ s }) => {
    const [bg,c] = (spMap[s]||"#F5F5F5:#9E9E9E").split(":");
    return <span className="text-[10px] font-semibold px-2.5 py-1 rounded-full whitespace-nowrap" style={{background:bg,color:c}}>{s}</span>;
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center py-24">
        <div className="flex flex-col items-center gap-2">
          <div className="w-8 h-8 rounded-full animate-spin"
            style={{ border: `3px solid ${T.border}`, borderTopColor: T.gold }} />
          <p className="text-[12px]" style={{ color: T.textSec }}>Loading dashboard...</p>
        </div>
      </div>
    );
  }

  if (loadError) {
    return (
      <div className="rounded-2xl bg-white p-6 text-center" style={{ border: `1px solid ${T.border}` }}>
        <p className="text-[13px] font-semibold" style={{ color: T.danger }}>{loadError}</p>
      </div>
    );
  }

  const STATS = [
    { icon:"🛒", label:"Total Orders",    value: data.stats.totalOrders,    sub:"" },
    { icon:"₹",  label:"Total Revenue",   value: data.stats.totalRevenue,   sub:"" },
    { icon:"📦", label:"Total Products",  value: data.stats.totalProducts,  sub:"" },
    { icon:"👥", label:"Total Customers", value: data.stats.totalCustomers, sub:"" },
  ];

  const MINI = [
    { label:"Pending Orders",  value: String(data.mini.pendingOrders),  color:T.warning, bg:"#FFF8EC" },
    { label:"Low Stock",       value: String(data.mini.lowStock),       color:T.warning, bg:"#FFF8EC" },
    { label:"Net Profit",      value: data.mini.netProfit,              color:T.success, bg:"#EEFAF0" },
    { label:"Refunds",         value: data.mini.refunds,                color:T.danger,  bg:"#FFF0F0" },
    { label:"New Customers",   value: String(data.mini.newCustomers),   color:T.gold,    bg:T.goldL   },
    { label:"Avg Order Value", value: data.mini.avgOrderValue,          color:T.success, bg:"#EEFAF0" },
  ];

  return (
    <div className="space-y-4 sm:space-y-6">
      {/* Welcome */}
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-[20px] sm:text-[26px] font-bold" style={{color:T.textPri,fontFamily:T.serif}}>Welcome back, Admin 🌿</h1>
          <p className="text-[12px] sm:text-sm mt-0.5" style={{color:T.textSec}}>Here's what's happening with your store today.</p>
        </div>
        <div className="flex items-center gap-2 overflow-x-auto no-scrollbar">
          <button onClick={() => setActive("products")}
            className="px-3 sm:px-4 py-2.5 rounded-xl text-[12px] sm:text-[13px] font-semibold text-white whitespace-nowrap flex-shrink-0"
            style={{background:T.gold}}>+ Add Product</button>
        </div>
      </div>

      {/* Primary stats */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
        {STATS.map(s => (
          <div key={s.label} className="rounded-2xl bg-white p-3.5 sm:p-5 hover:shadow-lg sm:hover:-translate-y-0.5 transition-all cursor-pointer"
            style={{border:`1px solid ${T.border}`,boxShadow:"0 2px 12px rgba(0,0,0,0.05)"}}>
            <div className="w-9 h-9 sm:w-12 sm:h-12 rounded-xl sm:rounded-2xl flex items-center justify-center text-base sm:text-xl mb-2 sm:mb-3" style={{background:T.goldL}}>{s.icon}</div>
            <p className="text-[16px] sm:text-[22px] font-bold leading-tight" style={{color:T.textPri}}>{s.value}</p>
            <p className="text-[10px] sm:text-[11px] mt-1" style={{color:T.textSec}}>{s.label}</p>
          </div>
        ))}
      </div>

      {/* Mini stats */}
      <div className="grid grid-cols-2 md:grid-cols-3 gap-2.5 sm:gap-3">
        {MINI.map(s => (
          <div key={s.label} className="rounded-2xl px-3 sm:px-4 py-2.5 sm:py-3 bg-white flex items-center gap-2.5 sm:gap-3 hover:shadow-md transition-all cursor-pointer"
            style={{border:`1px solid ${T.border}`}}>
            <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-lg sm:rounded-xl flex items-center justify-center flex-shrink-0" style={{background:s.bg}}>
              <div className="w-2 h-2 rounded-full" style={{background:s.color}}/>
            </div>
            <div className="min-w-0">
              <p className="text-[9px] sm:text-[10px] truncate" style={{color:T.textSec}}>{s.label}</p>
              <p className="text-[13px] sm:text-[15px] font-bold" style={{color:T.textPri}}>{s.value}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Order Status donut */}
      <div className="grid grid-cols-1 gap-4">
        <div className="rounded-2xl bg-white p-4 sm:p-5" style={{border:`1px solid ${T.border}`}}>
          <p className="text-[14px] sm:text-[15px] font-bold mb-1" style={{color:T.textPri,fontFamily:T.serif}}>Order Status</p>
          <p className="text-[10px] sm:text-[11px] mb-4" style={{color:T.textSec}}>All time</p>
          <div className="flex items-center gap-4 flex-wrap sm:flex-nowrap justify-center sm:justify-start">
            <DonutSVG data={data.orderDonut} total={String(data.totalOrdersForDonut)} label="Total" size={130}/>
            <div className="space-y-2.5">
              {data.orderDonut.map(s=>(
                <div key={s.label} className="flex items-center gap-2">
                  <div className="w-2.5 h-2.5 rounded-full flex-shrink-0" style={{background:s.color}}/>
                  <span className="text-[11px] w-20" style={{color:T.textSec}}>{s.label}</span>
                  <span className="text-[11px] font-bold" style={{color:T.textPri}}>{s.count}</span>
                  <span className="text-[10px]" style={{color:T.textSec}}>({s.pct}%)</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Tables */}
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-4">
        {/* Recent orders */}
        <div className="lg:col-span-3 rounded-2xl bg-white overflow-hidden" style={{border:`1px solid ${T.border}`}}>
          <div className="flex items-center justify-between px-4 sm:px-5 py-4 gap-2" style={{borderBottom:`1px solid ${T.border}`}}>
            <div className="min-w-0">
              <p className="text-[14px] sm:text-[15px] font-bold" style={{color:T.textPri,fontFamily:T.serif}}>Recent Orders</p>
              <p className="text-[10px] sm:text-[11px]" style={{color:T.textSec}}>Latest orders</p>
            </div>
            <button onClick={() => setActive("orders")}
              className="text-[11px] sm:text-[12px] font-semibold px-2.5 sm:px-3 py-1.5 rounded-xl border hover:bg-amber-50 whitespace-nowrap flex-shrink-0"
              style={{borderColor:T.gold,color:T.gold}}>View All →</button>
          </div>
          {data.recentOrders.length === 0 ? (
            <p className="text-[12px] text-center py-8" style={{color:T.textSec}}>No orders yet.</p>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full min-w-[560px]">
                <thead>
                  <tr style={{borderBottom:`1px solid ${T.border}`}}>
                    {["Order ID","Customer","Date","Pay","Status","Amount"].map(h=>(
                      <th key={h} className="px-4 py-3 text-left text-[10px] font-semibold uppercase tracking-wider" style={{color:T.textSec}}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {data.recentOrders.map((o,i)=>(
                    <tr key={o.id} className="transition-colors" style={{borderBottom:i<data.recentOrders.length-1?`1px solid ${T.bgSoft}`:""}}
                      onMouseEnter={e=>e.currentTarget.style.background=T.bgSoft}
                      onMouseLeave={e=>e.currentTarget.style.background=""}>
                      <td className="px-4 py-3.5 text-[12px] font-semibold font-mono" style={{color:T.textPri}}>{o.id}</td>
                      <td className="px-4 py-3.5"><div className="flex items-center gap-2"><Avatar name={o.name}/><span className="text-[12px]" style={{color:T.textPri}}>{o.name}</span></div></td>
                      <td className="px-4 py-3.5 text-[11px]" style={{color:T.textSec}}>{o.date}</td>
                      <td className="px-4 py-3.5"><SPill s={paymentLabel(o)}/></td>
                      <td className="px-4 py-3.5"><SPill s={o.status}/></td>
                      <td className="px-4 py-3.5 text-[12px] font-bold" style={{color:T.textPri}}>{o.amount}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {/* Best selling */}
        <div className="lg:col-span-2 rounded-2xl bg-white overflow-hidden" style={{border:`1px solid ${T.border}`}}>
          <div className="flex items-center justify-between px-4 sm:px-5 py-4" style={{borderBottom:`1px solid ${T.border}`}}>
            <div>
              <p className="text-[14px] sm:text-[15px] font-bold" style={{color:T.textPri,fontFamily:T.serif}}>Best Selling</p>
              <p className="text-[10px] sm:text-[11px]" style={{color:T.textSec}}>Top products (paid orders)</p>
            </div>
            <button onClick={() => setActive("products")} className="text-[11px] font-medium flex-shrink-0" style={{color:T.gold}}>See all</button>
          </div>
          {data.bestProducts.length === 0 ? (
            <p className="text-[12px] text-center py-8" style={{color:T.textSec}}>No sales data yet.</p>
          ) : (
            <div className="p-3 sm:p-4 space-y-1">
              {data.bestProducts.map(p=>(
                <div key={p.name} className="flex items-center gap-3 px-2 sm:px-3 py-3 rounded-2xl cursor-pointer transition-all"
                  onMouseEnter={e=>e.currentTarget.style.background=T.bgSoft}
                  onMouseLeave={e=>e.currentTarget.style.background=""}>
                  <div className="w-10 h-10 sm:w-11 sm:h-11 rounded-2xl flex items-center justify-center text-lg sm:text-xl flex-shrink-0"
                    style={{background:T.goldL,border:`1px solid ${T.champagne}`}}>📓</div>
                  <div className="flex-1 min-w-0">
                    <p className="text-[12px] font-semibold truncate" style={{color:T.textPri}}>{p.name}</p>
                    <p className="text-[10px] mt-0.5" style={{color:T.textSec}}>{p.sold.toLocaleString()} Sold</p>
                  </div>
                  <div className="text-right flex-shrink-0">
                    <p className="text-[12px] font-bold" style={{color:T.textPri}}>{p.revenue}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Quick actions */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
        {[
          { label:"Add Product",   emoji:"➕", desc:"List new item",    page:"products" },
          { label:"View Orders",   emoji:"📦", desc:"Manage orders",    page:"orders" },
          { label:"Analytics",     emoji:"📊", desc:"View insights",    page:"analytics" },
          { label:"Create Coupon", emoji:"🎟️", desc:"New discount code", page:"coupons" },
        ].map(a=>(
          <button key={a.label} onClick={() => setActive(a.page)}
            className="bg-white border rounded-2xl p-3 sm:p-4 text-left hover:shadow-md transition-all sm:hover:-translate-y-0.5 group"
            style={{borderColor:T.border}}>
            <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-xl flex items-center justify-center text-lg sm:text-xl mb-2.5 sm:mb-3 group-hover:scale-110 transition-transform"
              style={{background:T.goldL}}>{a.emoji}</div>
            <p className="text-[12px] sm:text-[13px] font-semibold" style={{color:T.textPri}}>{a.label}</p>
            <p className="text-[10px] sm:text-[11px] mt-0.5" style={{color:T.textSec}}>{a.desc}</p>
          </button>
        ))}
      </div>
    </div>
  );
}

// ════════════════════════════════════════════════════════════════════════════
// ROOT
// ════════════════════════════════════════════════════════════════════════════
export default function AdminDashboard() {
  const [active,      setActiveRaw]  = useState("dashboard");
  const [collapsed,   setCollapsed]  = useState(false);   // desktop: icon-only rail | mobile: drawer open/closed
  const [authChecked, setAuthChecked] = useState(false);
  const [authed,      setAuthed]      = useState(false);
  const [adminInfo,   setAdminInfo]   = useState(null);
  const isMobile = useIsMobile(1024);
  const [notifications, setNotifications] = useState([]);

  // On mobile the sidebar behaves like a hamburger drawer:
  // collapsed=true  -> drawer hidden (off-canvas)
  // collapsed=false -> drawer open (overlay)
  // Start hidden on mobile so the icon rail never sits visible on load.
  useEffect(() => {
    if (isMobile) setCollapsed(true);
  }, [isMobile]);

  // Wrap navigation so that picking any page auto-closes the mobile drawer.
  const setActive = (page) => {
    setActiveRaw(page);
    if (isMobile) setCollapsed(true);
  };

  useEffect(() => {
    const token = getToken();
    if (!token) { setAuthChecked(true); return; }
    apiFetch("/auth/verify.php")
      .then(res => { setAdminInfo(res.data.admin); setAuthed(true); })
      .catch(() => { clearToken(); setAuthed(false); })
      .finally(() => setAuthChecked(true));
  }, []);

  const handleLogout = async () => {
    try { await apiFetch("/auth/logout.php", { method: "POST" }); } catch {}
    clearToken();
    setAuthed(false);
    setAdminInfo(null);
  };

  const handleLogin = (admin) => {
    setAdminInfo(admin);
    setAuthed(true);
  };

  if (!authChecked) {
    return (
      <div className="flex items-center justify-center min-h-screen" style={{ background: T.bg }}>
        <p className="text-[13px]" style={{ color: T.textSec }}>Loading…</p>
      </div>
    );
  }

  if (!authed) {
    return <AdminLogin onLogin={handleLogin} />;
  }

  const PAGES = {
    dashboard:  <DashboardHome setActive={setActive} />,
    orders:     <OrdersAdmin />,
     products:   <ProductsAdmin />,  
  
    leads:       <LeadsAdmin />,
    customers:  <CustomersAdmin />,
    reviews:    <ReviewsAdmin />,
    coupons:    <CouponsAdmin />,
    inventory:  <InventoryAdmin />,
    analytics:  <AnalyticsAdmin />,
    blogs:      <BlogsAdmin />,
    settings:   <SettingsAdmin />,

    // Remaining pages — add as you build them
    categories: <ComingSoon title="Categories" />,
    payments:   <ComingSoon title="Payments" />,
    shipping:   <ComingSoon title="Shipping" />,
    returns:    <ComingSoon title="Return Requests" />,
    photobooks: <PhotobooksAdmin />, 
      "photobook-orders": <PhotobookOrdersAdmin />, 
    diaries:    <ComingSoon title="Diaries" />,
    corporate:  <ComingSoon title="Corporate Orders" />,
    gifts:      <ComingSoon title="Gift Hampers" />,
    custom:     <ComingSoon title="Custom Orders" />,
    media:      <ComingSoon title="Media Library" />,


   
      HomeCircle: <HomeCircle title="Home Circle"  />, 
      HomeDaily:  <HomeDaily title="Home Daily"  />, 
      HomeSlider : <HomeSlider title="Home Slider"  />,
      HomeNotebook : <HomeNotebook title="Home Notebook"  />,
      HomePromotional : <HomePromotional title="Home Promotional"  />,
      HomeClient : <HomeClientSuccess title="Home Client"  />,
      HomeVideo : <HomeVideo title="Home Reels"  />,
      
    newsletter: <Newsletter title="Newsletter" />,
   contact:    <InquiriesAdmin />,
    users:      <ComingSoon title="Users & Roles" />,
    giftcards:  <ComingSoon title="Gift Cards" />,
  };

  // On mobile, the drawer floats above content (no content margin, fixed position,
  // slides in/out). On desktop it pushes content over as before.
  const sidebarOpenOnMobile = isMobile && !collapsed;

  return (
    <div className="flex min-h-screen" style={{ background: T.bg, fontFamily: T.sans }}>

      {/* Dark backdrop behind the drawer on mobile — tap to close */}
      {isMobile && (
        <div
          onClick={() => setCollapsed(true)}
          className="fixed inset-0 z-40 transition-opacity duration-300"
          style={{
            background: "rgba(20,16,10,0.45)",
            opacity: sidebarOpenOnMobile ? 1 : 0,
            pointerEvents: sidebarOpenOnMobile ? "auto" : "none",
          }}
        />
      )}

      {/* Sidebar wrapper: fixed + slide-in on mobile, static rail on desktop */}
      <div
        className="transition-transform duration-300 ease-out"
        style={
          isMobile
            ? {
                position: "fixed",
                top: 0,
                left: 0,
                bottom: 0,
                zIndex: 50,
                transform: sidebarOpenOnMobile ? "translateX(0)" : "translateX(-100%)",
              }
            : { position: "relative", zIndex: 30 }
        }
      >
        <AdminSidebar
          active={active}
          setActive={setActive}
          collapsed={isMobile ? false : collapsed}
          setCollapsed={setCollapsed}
          onLogout={handleLogout}
        />
      </div>

      <div
        className="flex-1 flex flex-col min-w-0"
        style={{
          marginLeft: isMobile ? 0 : (collapsed ? 68 : 228),
          transition: "margin-left .3s",
        }}
      >
        <AdminTopbar
          active={active}
          setActive={setActive}
          onLogout={handleLogout}
          isMobile={isMobile}
          menuOpen={sidebarOpenOnMobile}
          onToggleMenu={() => setCollapsed(c => !c)}
        />
        <main className="flex-1 p-3 sm:p-6 overflow-auto">
          {PAGES[active] || <ComingSoon title={active} />}
        </main>
        <footer className="px-4 sm:px-6 py-3 flex flex-col sm:flex-row items-center justify-between gap-1 text-center sm:text-left" style={{ borderTop:`1px solid ${T.border}`, background:T.card }}>
          <p className="text-[10px] sm:text-[11px]" style={{ color:T.textSec }}>© 2025 Aishcraft. All rights reserved.</p>
          <p className="text-[10px] sm:text-[11px]" style={{ color:T.textSec }}>Admin Panel v1.0.0</p>
        </footer>
      </div>
    </div>
  );
}

function ComingSoon({ title }) {
  return (
    <div className="flex flex-col items-center justify-center h-72 text-center px-4">
      <div className="w-16 h-16 rounded-3xl flex items-center justify-center text-3xl mb-4"
        style={{ background:"#F5EDE0" }}>🏗️</div>
      <h2 className="text-[18px] sm:text-[20px] font-bold mb-2" style={{ color:"#2B2B2B", fontFamily:"'Cormorant Garamond',Georgia,serif" }}>{title}</h2>
      <p className="text-[12px]" style={{ color:"#777777" }}>This page is ready to build. Add your component in <code className="bg-gray-100 px-1 rounded">PAGES</code> map.</p>
    </div>
  );
}